<template>
  <div>
    <bs-page-title
      :titleLabel="'販売データ一覧'"
      :btnLabel="''"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div class="card">
        <div class="card-header bg-light">
          <div class="card-title mb-0">検索条件</div>
        </div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-6">
              <label class="form-label">登録日付範囲</label>
              <div class="input-group">
                <input
                  type="date"
                  class="form-control"
                  v-model="search_params.cre_date_lower"
                />
                <span class="input-group-text">から</span>
                <bs-select
                  :options="day_count_list"
                  v-model="target_day_count"
                  :null-option="false"
                  id="target_day_count"
                  :PrefCd="'form-select'"
                ></bs-select>
                {{ search_params.cre_date_higher }}
                <!-- <input
                  type="date"
                  class="form-control"
                  v-model="search_params.sales_date_higher"
                /> -->
              </div>
            </div>
            <div class="col-md-6" v-if="false">
              <label class="form-label">販売日付範囲</label>
              <div class="input-group">
                <input
                  type="date"
                  class="form-control"
                  v-model="search_params.sales_date_lower"
                />
                <span class="input-group-text">から</span>
                <bs-select
                  :options="day_count_list"
                  v-model="target_day_count"
                  :null-option="false"
                  id="target_day_count"
                  :PrefCd="'form-select'"
                ></bs-select>
                <!-- <input
                  type="date"
                  class="form-control"
                  v-model="search_params.sales_date_higher"
                /> -->
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">種別</label>
              <bs-select
                :options="application_type_list"
                v-model="search_params.application_type"
                :null-option="true"
                nullText="すべて"
                id="application_type"
                :PrefCd="'form-select'"
              ></bs-select>
            </div>
            <div class="col-md-3">
              <label class="form-label">支払状態</label>
              <bs-select
                :options="charge_status_list"
                v-model="search_params.charge_status"
                :null-option="true"
                nullText="すべて"
                id="charge_statu"
                :PrefCd="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="row">
            <div class="col text-center"></div>
            <div class="col text-center">
              <button
                type="button"
                class="btn btn-primary"
                @click="searchData"
                :disabled="chkSearch"
              >
                条件で検索
              </button>
            </div>
            <div class="col text-end">
              <button
                type="button"
                class="btn btn-light btn-outline-secondary"
                @click="clearSearch"
              >
                検索条件クリア
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w100" v-if="!isLoading && sales_data_list.length > 0">
      <h5>検索結果</h5>
      <div class="card mb-4">
        <div class="card-header bg-light">
          <div class="d-flex justify-content-between align-items-center">
            <span>検索結果: 全{{ total_count }}件</span>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-striped table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>ID</th>
                  <th>注文ID</th>
                  <th>種別</th>
                  <th>金額</th>
                  <th>登録日</th>
                  <th>支払方法</th>
                  <th>支払状態</th>
                  <th>支払期限</th>
                  <th>決済完了日</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in sales_data_list" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.charge_order_id }}
                    <hr v-if="item.payer_data" style="margin: 3px 0" />
                    <p v-if="item.payer_data" style="margin-bottom: 0">
                      [{{ item?.payer_data?.number }}]&nbsp;
                      {{ item?.payer_data?.label }}
                    </p>
                  </td>
                  <td v-if="item.sales_type.indexOf('owner_') >= 0">
                    {{ getOApplicationTypeLabel(item.sales_type) }}
                  </td>
                  <td v-else>
                    {{ getApplicationTypeLabel(item.application_type) }}
                  </td>
                  <td>{{ formatCurrency(item.amount) }}円</td>
                  <td>
                    {{ formatDate(item.cre_date) }}
                  </td>
                  <td>{{ getChargeTypeLabel(item.charge_type) }}</td>
                  <td>{{ getStatusLabel(item.sales_date) }}</td>
                  <td>
                    {{
                      formatDate(
                        item.payment_expiry_date ||
                          item.cash_payment_expiry_date
                      )
                    }}
                  </td>
                  <td>{{ formatDate(item.sales_date) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <bs-page-nav
          :pager="pager"
          :pager_key="'sales_list'"
          @page-change="changePage"
        ></bs-page-nav>
      </div>
    </div>

    <div
      v-if="!isLoading && sales_data_list.length === 0"
      class="alert alert-warning"
    >
      <p>検索結果は0件です。条件を見直してください。</p>
    </div>

    <div v-if="isLoading" class="text-center p-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">読み込み中...</p>
    </div>
  </div>
</template>

<script>
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
import config from '../../../const'

export default {
  components: {
    BsPageTitle,
    BsMsgAlert,
    BsSelect,
    BsPageNav
  },
  data() {
    return {
      alertClass: 'alert-info',
      alertMessage: '',
      isLoading: false,

      target_day_count: 30,
      // 検索条件
      search_params: {
        sales_date_lower: '',
        sales_date_higher: '',
        application_type: '',
        charge_status: '',
        cre_date_lower: '',
        cre_date_higher: '',
        page: 1,
        limit: 20
      },

      // データ
      sales_data_list: [],
      total_count: 0,
      current_page: 1,
      per_page: 20,
      pager: {
        sales_list: {
          current_page: 1,
          last_page: 1,
          per_page: 20,
          total: 0
        }
      },

      // 選択肢
      application_type_list: [
        { key: '1000', label: '会員入会' },
        { key: '1300', label: '会員継続・追加' },
        { key: '1500', label: '会員販売' },
        { key: '11300', label: '競技会申請' },
        { key: '11500', label: '主催者販売' }
      ],
      o_application_type_list: [
        { key: 'owner_event', label: '競技会申請' },
        { key: 'owner_general', label: '主催者販売' }
      ],
      charge_status_list: [
        { key: '9', label: '未決済' },
        { key: '1', label: '決済完了' }
      ],
      charge_type_list: [
        { id: 'CREDIT', label: 'クレジットカード' },
        { id: 'CASH', label: 'コンビニ決済' }
      ],
      status_list: [
        { id: '1', label: '未決済' },
        { id: '9', label: '決済完了' }
      ]
    }
  },
  async mounted() {
    // 初期検索
    // this.searchData()
  },
  computed: {
    chkSearch: function () {
      if (
        this.search_params?.sales_date_lower != '' ||
        this.search_params?.cre_date_lower != ''
      )
        return false
      return true
    },
    day_count_list: function () {
      const tmps = []
      for (let i = 0; i < 31; i++) {
        tmps.push({
          key: i,
          label: String(i + 1) + '日分のデータ'
        })
      }
      return tmps
    }
  },
  methods: {
    /**
     * YYYY-MM-DD と日数を受け取り、YYYY-MM-DD を返す
     * @param {string} dateStr - 'YYYY-MM-DD'
     * @param {number} days - 加算する日数（マイナスで減算）
     * @returns {string} - 'YYYY-MM-DD'
     */
    addDays(dateStr, days) {
      const [y, m, d] = dateStr.split('-').map(Number)
      // UTCで扱う（タイムゾーンずれ防止）
      const date = new Date(Date.UTC(y, m - 1, d))
      date.setUTCDate(date.getUTCDate() + parseInt(days))
      const yyyy = date.getUTCFullYear()
      const mm = String(date.getUTCMonth() + 1).padStart(2, '0')
      const dd = String(date.getUTCDate()).padStart(2, '0')

      return `${yyyy}-${mm}-${dd}`
    },

    async searchData() {
      this.isLoading = true
      this.alertMessage = ''
      this.current_page = this.search_params.page || 1

      try {
        const params = { ...this.search_params }
        params.sales_date_higher = params.sales_date_lower
          ? this.addDays(params.sales_date_lower, this.target_day_count)
          : ''
        params.cre_date_higher = this.addDays(
          params.cre_date_lower,
          this.target_day_count
        )
        params.pagegroup = 'mfj_sales_data.id'
        if (parseInt(params.application_type) > 10000) {
          if (params.application_type == 11300) {
            params.sales_type = 'owner_event'
          } else if (params.application_type == 11500) {
            params.sales_type = 'owner_general'
          }
          delete params.application_type
        }
        // API呼び出し
        const res = await this.basicPosts_S(
          config.BASE_API_URL + '/sales/lists',
          params
        )

        if (res?.data?.status === 200) {
          this.sales_data_list = res.data.body || []
          this.total_count = res.data.all_count || 0

          // ページャー情報を更新
          this.pager.sales_list = {
            current_page: this.current_page,
            last_page: Math.ceil(this.total_count / this.per_page),
            per_page: this.per_page,
            total: this.total_count
          }
          this.alertClass = 'alert-success'
          this.alertMessage = '販売データ一覧です。'
        } else {
          this.alertClass = 'alert-danger'
          this.alertMessage = 'データの取得に失敗しました'
          this.sales_data_list = []
          this.total_count = 0
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.alertClass = 'alert-danger'
        this.alertMessage = 'エラーが発生しました: ' + error.message
        this.sales_data_list = []
        this.total_count = 0
      } finally {
        this.isLoading = false
      }
    },
    changePage(page) {
      this.search_params.page = page
      this.current_page = page
      this.searchData()
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return isNaN(date) ? '-' : date.toLocaleDateString('ja-JP')
    },
    formatCurrency(value) {
      if (!value) return '0'
      return Number(value).toLocaleString()
    },
    getApplicationTypeLabel(type) {
      if (!type) return '-'
      const found = this.application_type_list.find(
        item => item.key === type.toString()
      )
      return found ? found.label : type.toString()
    },
    getOApplicationTypeLabel(type) {
      if (!type) return '-'
      const found = this.o_application_type_list.find(
        item => item.key === type.toString()
      )
      return found ? found.label : type.toString()
    },
    getChargeTypeLabel(type) {
      if (!type) return '-'
      const found = this.charge_type_list.find(item => item.id === type)
      return found ? found.label : type
    },
    getStatusLabel(date) {
      if (date === undefined || date == '0000-00-00' || date === null)
        return '-'
      const status = date ? 9 : 1
      const found = this.status_list.find(item => item.id === status.toString())
      return found ? found.label : status.toString()
    },
    clearSearch() {
      this.search_params = {
        sales_date_lower: '',
        sales_date_higher: '',
        application_type: '',
        page: 1,
        limit: 20
      }
      this.searchData()
    }
  }
}
</script>

<style scoped>
.table th {
  white-space: nowrap;
}
</style>
